import { onDocumentReady } from '../utils/dom';

function init() {
    class Collapsable extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        onDocumentReady(() => {
            this.headerElement = this.querySelector("[data-component='header'");
            this.bodyElement = this.querySelector("[data-body='header']");
            this.init();
            if (!document.querySelector('expended-accordion.active')) {
                this.classList.add('active');
            }
        })
    }

    init() {
        this.headerElement.addEventListener("click", () => {
            this.closeAllCollapsibles();
            this.toggle();
        });
    }

    toggle() {
        this.classList.toggle("active");
    }
    closeAllCollapsibles() {
        const allCollapsibles = document.querySelectorAll('expended-accordion');
        allCollapsibles.forEach(collapsible => {
            if (collapsible !== this && collapsible.classList.contains('active')) {
                collapsible.toggle();
            }
        });
    }
}

customElements.define('expended-accordion', Collapsable)
}

export default init;